import React from "react";
import "./Benifits.css";
import Common_Title_2 from "../../common/common_components/common_title_2/Common_Title_2";

const Benifits = ({ benefits }) => {
  const data = [
    {
      no: "01",
      title: "Reduces Stress & Anxiety",
      descn: "Calms the nervous system and relaxes the mind.",
    },
    {
      no: "02",
      title: "Improves Focus & Concentration",
      descn: "Trains the brain to stay present.",
    },
    {
      no: "03",
      title: "Enhances Emotional Health",
      descn: "Promotes a positive mood and inner stability",
    },
    {
      no: "04",
      title: "Better Sleep Quality",
      descn: "Helps release tension & quiet the mind before bed",
    },
  ];

  // console.log({ benefits });


  return (
    benefits?.length > 0 && (

      < section className="Benifits" >
        <div className="container">
          <Common_Title_2 subText="Benefits" />

          <div className="cards_holder">
            <div className="row">
              {benefits?.map((item, index) => {
                return (
                  <div className="col-lg-3 col-md-4 col-sm-6 mb-4">
                    <div className="benifits_card">
                      <div className="gray_div">
                        <div className="count_div">
                          <p className="count_text">{`${index + 1 < 10 ? `0${index + 1}` + 1 : index + 1}`}</p>
                        </div>
                        <p className="title_text">{item?.title}</p>
                      </div>
                      <div className="bottom_div">
                        <p className="descn_text">{item?.descn}</p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </ section >
    )
  );
};

export default Benifits;
